const DomainIgnoredUrlsColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 80,
  },
  {
    title: 'Ignored URL',
    dataIndex: 'url',
    slot: 'url',
    width: 600,
  },
  {
    title: '',
    dataIndex: '',
    width: 80,
    slot: 'operation',
  },
];

export { DomainIgnoredUrlsColumn };